export default __webpack_public_path__ + "e62db61.png";